import React from 'react';
import { Segment, Divider } from 'semantic-ui-react';
import { SemanticContainer, SemanticSegment } from './styled';

import { withRouter } from 'react-router-dom';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu'
import Back from '../../../../components/Admin/Eventos/FormularioEditar/Back';
import FormularioEditar from '../../../../components/Admin/Eventos/FormularioEditar';

const EventosCadastro = props => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Editar Evento</h2>
        <Divider />
        <Segment>
          <FormularioEditar />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2020
        </SemanticSegment>
      </SemanticContainer>
    </>
  )
}

export default withRouter(EventosCadastro);